"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _useOnclickoutside = _interopRequireDefault(require("use-onclickoutside"));
var _useCloseOnEsc = require("./useCloseOnEsc");
/**
 *
 * This hook can be used for certain scenarios which use common actions like the modal for example. These actions
 * are wrapped in useCallbacks in order to avoid unnecessary rerenders.
 *
 * @param initialValue the initial state value. The default is false
 */

/**
 * This hook can be used for certain scenarios which use common actions like the modal for example. These actions
 * are wrapped in useCallbacks in order to avoid unnecessary rerenders.
 *
 * @param {Boolean} initialValue the initial state value. The default is false
 * @param {Object} options options - options object
 * @param {Boolean} options.closeOnClickOutside closeOnClickOutside - needs ref to be set in order for closing when clicking outside that ref
 * @param {Boolean} options.closeOnEscape closeOnEscape - close when the user presses the escape key
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useSesame = function useSesame() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    closeOnClickOutside: false,
    closeOnEscape: false
  };
  var closeOnClickOutside = options.closeOnClickOutside,
    closeOnEscape = options.closeOnEscape;
  var _useState = (0, _react.useState)(initialValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var onClose = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, []);
  var onOpen = (0, _react.useCallback)(function () {
    return setOpen(true);
  }, []);
  var onToggle = (0, _react.useCallback)(function () {
    return setOpen(function (prevOpen) {
      return !prevOpen;
    });
  }, []);
  var ref = (0, _react.useRef)(null);
  (0, _useCloseOnEsc.useCloseOnEsc)(closeOnEscape ? {
    open: open,
    setOpen: setOpen
  } : undefined);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (0, _useOnclickoutside["default"])(ref, function () {
    if (closeOnClickOutside && open) {
      setOpen(false);
    }
  });
  return {
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    ref: ref
  };
};
var _default = exports["default"] = useSesame;
//# sourceMappingURL=useSesame.js.map